module.exports = __webpack_public_path__ + "static/media/Kubitos_golden_text.d89290b8.png";